import type { FC } from 'react';
import { WithdrawalContent } from './components/WithdrawalContent/WithdrawalContent';
import { WithdrawalProvider } from './Withdrawal.context';
export const Withdrawal: FC = () => {
  return <WithdrawalProvider data-sentry-element="WithdrawalProvider" data-sentry-component="Withdrawal" data-sentry-source-file="Withdrawal.tsx">
      <WithdrawalContent data-sentry-element="WithdrawalContent" data-sentry-source-file="Withdrawal.tsx" />
    </WithdrawalProvider>;
};